<template>
  <b-form-group label="Evento" v-if="eventos.length || value" class="mb-0">
    <b-form-select size="sm" :value="value" @change="$emit('input', $event)" :options="opciones"></b-form-select>
    <small class="text-muted">Opcional. Solo aparecen los eventos vigentes del motivo para este cliente.</small>
  </b-form-group>
</template>
<script>
  import serviceAPI from './services'

  // Selector de evento del motivo al cargar un pedido (admin y vendedores). Se recarga cuando cambia
  // motivo, cliente o fecha; si el evento elegido deja de estar disponible, se limpia. En edición
  // (includeID) muestra el evento que ya tiene el pedido aunque ya no esté vigente.
  export default {
    props: {
      value: { default: null },
      reason_id: { default: 0 },
      customers_id: { default: 0 },
      date: { default: '' },
      includeID: { default: null },
    },
    data() {
      return {
        eventos: [],
      }
    },
    computed: {
      opciones() {
        var opciones = [{ value: null, text: 'Sin evento' }]
        this.eventos.forEach(evento => {
          opciones.push({
            value: evento.id,
            text: evento.name + ' (' + this.formatearFecha(evento.date_start) + ' al ' +
                  this.formatearFecha(evento.date_end) + ')',
          })
        })
        return opciones
      },
      clave() {
        return [this.reason_id, this.customers_id, this.date].join('|')
      },
    },
    watch: {
      clave() {
        this.cargar()
      },
    },
    mounted() {
      this.cargar()
    },
    methods: {
      formatearFecha(fecha) {
        var partes = (fecha || '').substring(0, 10).split('-')
        return partes.length == 3 ? partes[2] + '/' + partes[1] : fecha
      },
      cargar() {
        if(!this.reason_id || !this.customers_id) {
          this.eventos = []
          if(this.value) {
            this.$emit('input', null)
          }
          return
        }

        serviceAPI.obtenerEventosDisponibles(this.reason_id, this.customers_id, this.date, this.includeID)
        .then((response) => {
          this.eventos = response.data
          if(this.value && !this.eventos.find(e => e.id == this.value)) {
            this.$emit('input', null)
          }
        })
        .catch(() => {
          this.eventos = []
        })
      },
    },
  }
</script>
